<template>
  <div id="app">
    <router-view></router-view>
    <modal-alert v-if="$store.getters.getIsShowModal" @close="closeModal" :message="$store.getters.getModalMessage" :modalWidth="$store.getters.getModalWidth"></modal-alert>
  </div>
</template>

<script>
import ModalAlert from '@/components/ModalAlert'
export default {
  name: 'App',
  components: {
    ModalAlert
  },
  methods: {
    /*
     * Close modal
     *
     * @return void
     */
    closeModal () {
      $('#myModal').modal('hide')
      this.$store.commit('toggleModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue